module.exports = __webpack_public_path__ + "static/media/webDocumentationIntro.80a59c69.jpg";